import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconList } from '@sorare/core/src/atoms/icons/system/iconList.ts';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS, LabelL } from '@sorare/core/src/atoms/typography';

import { AddWatchlistButton } from '#src/components/watchlists/AddWatchlistButton/index.tsx';

const Root = styled(Vertical)`
  flex-grow: 1;
  border: 1px dashed var(--c-nd-150);
  border-radius: var(--double-unit);
`;

type Props = {
  onAddWatchlist: () => void;
};

export const EmptyState = ({ onAddWatchlist }: Props) => {
  return (
    <Root className="text-center" center>
      <Vertical gap={2} center>
        <Vertical center>
          <FontAwesomeIcon icon={iconList} size="xl" />
          <Vertical gap={0.5}>
            <HeadlineS>
              <FormattedMessage defaultMessage="No watchlist yet" />
            </HeadlineS>
            <LabelL color="var(--c-nd-600)">
              <FormattedMessage defaultMessage="Start by creating your first one" />
            </LabelL>
          </Vertical>
        </Vertical>
        <AddWatchlistButton
          onSuccess={onAddWatchlist}
          size="small"
          color="secondary"
          blur
        />
      </Vertical>
    </Root>
  );
};
